const ADD_AIRSPOT = 'airspots/addAirspot'
const REMOVE_AIRSPOT = 'airspots/removeAirspot'

const obj = {
  ADD_AIRSPOT,
  REMOVE_AIRSPOT,
}

export default obj
